import './style.scss';
import React from "react";

const Links: React.FC<{ onlyFAQ: boolean }> = props => {
    return <></>;
}

export default Links;
